import { render } from "./MyView.vue?vue&type=template&id=476e8c16&scoped=true"
import script from "./MyView.vue?vue&type=script&lang=js"
export * from "./MyView.vue?vue&type=script&lang=js"

import "./MyView.vue?vue&type=style&index=0&id=476e8c16&lang=scss&scoped=true"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-476e8c16"]])

export default __exports__